import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "../src/styles/globals.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "swiper/css/a11y";
import "animate.css";
import AppRoutes from "./routers/Routes";
import Footer from "./components/layout/Footer";
import DoctorInterestsGate from "./components/common/DoctorInterestsGate";
import NotificationEmailGate from "./components/common/NotificationEmailGate";
import Swal from "sweetalert2";
import { AuthProvider } from "./providers/AuthProvider";

// Componente para manejo global de errores
const GlobalErrorHandler = ({ children }) => {
  React.useEffect(() => {
    const handleError = (event) => {
      const error = event.error;

      const isExpiredSession =
        error?.message === "Sesión expirada" ||
        error?.response?.status === 401;

      if (isExpiredSession) {
        import('./utils/tokenUtils').then(({ tokenUtils }) => {
          tokenUtils.clearAuth();
        });

        Swal.fire({
          title: "Sesión expirada",
          text: "Tu sesión ha expirado. Por favor, inicia sesión nuevamente.",
          icon: "warning",
          confirmButtonText: "Aceptar",
        }).then(() => {
          window.location.reload();
        });
      }
    };

    window.addEventListener("error", handleError);
    return () => window.removeEventListener("error", handleError);
  }, []);

  return <>{children}</>;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <GlobalErrorHandler>
          <AppRoutes />
          <Footer />
          <DoctorInterestsGate />
          <NotificationEmailGate />
        </GlobalErrorHandler>
      </Router>
    </AuthProvider>
  );
}

export default App;
